import styled from 'styled-components';

const BasicDivFlexBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export default BasicDivFlexBetween;
